var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top-bar-settings__container" }, [
    _c(
      "div",
      { staticClass: "top-bar-settings__list top-bar-settings__list--1" },
      [
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--1",
            attrs: { href: _vm.link1 }
          },
          [_vm._v(_vm._s(_vm.text1))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--2",
            attrs: { href: _vm.link2 }
          },
          [_vm._v(_vm._s(_vm.text2))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--3",
            attrs: { href: _vm.link3 }
          },
          [_vm._v(_vm._s(_vm.text3))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--4",
            attrs: { href: _vm.link4 }
          },
          [_vm._v(_vm._s(_vm.text4))]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--5",
            attrs: { href: _vm.link5 }
          },
          [_vm._v(_vm._s(_vm.text5))]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "top-bar-settings__list top-bar-settings__list--2" },
      [
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--6",
            attrs: { href: _vm.link6 }
          },
          [
            _c("img", { attrs: { src: _vm.img1, alt: "icon" } }),
            _vm._v(_vm._s(_vm.text6))
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "top-bar-settings__item top-bar-settings__item--7",
            attrs: { href: _vm.link7 }
          },
          [
            _c("img", { attrs: { src: _vm.img2, alt: "icon" } }),
            _vm._v(_vm._s(_vm.text7))
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }